<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.SELECT_BOOKMAKER_ID_TO_CHANGE"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent ref="modal" type="modal" noInnerPadding>
    <div class="bg-gray-50 p-6">
      <!-- Header -->
      <div class="text-center mb-6">
        <div class="w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center shadow-lg bg-secondary">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
          </svg>
        </div>
        <h2 class="text-2xl font-bold text-gray-800">
          Sélectionnez l'ID à changer
        </h2>
      </div>

      <!-- Bookmaker List -->
      <div class="flex flex-col gap-3">
        <div
          v-for="(bookmaker, key) in $constants.BOOKMAKER.INFOS"
          :key="key"
          class="bg-white rounded-2xl shadow-md shadow-gray-200/50 overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] group"
          @click="
            () => {
              $bus.emit(
                $constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE,
                {
                  bookmaker: key
                }
              );
            }
          "
        >
          <div class="flex items-center gap-4 p-4">
            <!-- Logo -->
            <div class="w-14 h-14 min-w-14 rounded-xl bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center shadow-inner overflow-hidden">
              <ImgComponent :src="bookmaker.logo" class="w-10 h-10 object-cover" />
            </div>

            <!-- Info -->
            <div class="flex flex-col flex-1">
              <div class="text-lg font-bold text-gray-800 group-hover:text-secondary-600 transition-colors">
                {{ bookmaker.name }}
              </div>
              <div class="text-sm text-gray-500">
                {{ bookmaker.description }}
              </div>
            </div>

            <!-- Arrow -->
            <div class="w-8 h-8 min-w-8 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-secondary-200 transition-colors">
              <svg class="w-4 h-4 text-secondary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Cancel Button -->
      <button
        class="w-full mt-6 py-4 px-6 font-semibold rounded-2xl border-2 transition-all duration-300 flex items-center justify-center gap-3 hover:bg-gray-100 active:scale-[0.98] border-gray-300 text-gray-600"
        @click="() => $refs.modal.hide()"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
        Annuler
      </button>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BookmakerAccountToSetSelecot'
});
</script>
